const DOC_SOURCE_META = {
  om: { label: 'OM', longLabel: 'Offering Memo' },
  rentRoll: { label: 'RR', longLabel: 'Rent Roll' },
  t12: { label: 'T12', longLabel: 'T12 / P&L' },
}

export const getParsedFieldSources = (parsedDocuments = {}, fieldKey) => {
  if (!fieldKey) return []

  return Object.entries(parsedDocuments || {}).flatMap(([docId, status]) => {
    const value = status?.fields?.[fieldKey]
    const hasValue = value !== '' && value !== null && value !== undefined
    if (!hasValue) return []

    const meta = DOC_SOURCE_META[docId] || { label: docId.toUpperCase(), longLabel: docId }
    return [{
      id: docId,
      label: meta.label,
      longLabel: meta.longLabel,
      fileName: status?.fileName || '',
    }]
  })
}

export const formatFieldSources = (sources = []) => {
  if (!sources.length) return 'Manual / not extracted from OM, RR, or T12'
  return sources
    .map(source => source.fileName
      ? `${source.label} (${source.fileName})`
      : source.label)
    .join(' + ')
}

export const getSourceSummary = (parsedDocuments = {}, fieldKey) => (
  formatFieldSources(getParsedFieldSources(parsedDocuments, fieldKey))
)
